<template>
  <div
    :id="`form_field_${field.fieldname}`"
    class="form_field"
  >
    <div
      :class="((field.fieldtype === 'checkbox' || field.fieldtype === 'radio') && field.others.length > 75)? 'd-flex': ''"
    >
      <template v-if="field.fieldtype === 'textarea'">
        <textarea
          :id="`${field.fieldtype}_${field.fieldname}`"
          v-model.trim="value"
          rows="5"
          :name="field.fieldname"
          :placeholder="field.placeholder"
          @change="checkField"
        />
      </template>
      <template v-else-if="field.fieldtype === 'file'">
        <a
          v-if="value && value !== '' && typeof value === 'string'"
          :href="getAssetLink(value)"
          target="_blank"
          class="uploaded_file"
        >{{ $t("component.form.uploaded_file") }}: {{ getFileName(value) }}</a>
        <b-form-file
          :id="`${field.fieldtype}_${field.fieldname}`"
          v-model="value"
          :name="field.fieldname"
          plain
          @change="checkFile"
        />
      </template>
      <template v-else-if="field.fieldtype === 'dropdown'">
        <b-form-select
          :id="`${field.fieldtype}_${field.fieldname}`"
          v-model="value"
          :placeholder="field.placeholder"
          @change="checkField"
        >
          <option
            v-for="(option, i) in field.fieldoption"
            :id="`${field.fieldname}_option_${i}`"
            :key="`${field.fieldname}_option_${i}`"
            :value="option.value"
            :class="other_option && option.value === other_option.value? 'switch_option_other': ''"
          >
            {{ option.name }}
          </option>
        </b-form-select>
        <div
          v-if="other_option"
          v-show="value === other_option.value"
          class="mt-2"
        >
          <input
            :id="`${field.fieldname}_option__other`"
            v-model="additional[other_option.withTextName]"
            class="d-inline-block w-auto"
            type="text"
          >
          <label
            v-if="other_option.withTextNameOther!== ''"
            class="d-inline-block ml-2"
            v-html="other_option.withTextNameOther"
          />
        </div>
      </template>
      <template v-else-if="field.fieldtype === 'date'">
        <div>
          <datepicker
            :id="`${field.fieldtype}_${field.fieldname}`"
            v-model="value"
            :format="customFormatter"
            v-bind="disabledDates ? { disabledDates: disabledDates}: { }"
            :language="translation[$i18n.locale]"
            :placeholder="field.placeholder"
            @change="checkField"
          />
        </div>
      </template>
      <template v-else-if="field.fieldtype === 'checkbox' || field.fieldtype === 'radio'">
        <div
          v-for="(option, i) in field.fieldoption"
          :id="`${field.fieldname}${i}`"
          :key="`${field.fieldname}${i}`"
          :class="(field.fieldtype === 'radio' && option.type !== 'withText')? 'd-inline-block mr-3': 'd-block'"
        >
          <div
            class="form_field_inner"
            :class="value === option.value? 'selected': ''"
          >
            <input
              :id="`${field.fieldname}_option_${i}`"
              v-model="value"
              :type="field.fieldtype"
              :value="option.value"
              class="float-left"
              :class="option.type === 'withText'? 'switch_option_other': ''"
              @change="checkField"
            >
            <label
              :for="`${field.fieldname}_option_${i}`"
              v-html="option.name"
            />
            <template v-if="option.type === 'withText'">
              <input
                :id="`${field.fieldname}_option_other`"
                v-model="additional[option.withTextName]"
                class="d-inline-block w-auto ml-2"
                type="text"
                @change="selectOption(option.value)"
              >
              <label
                v-if="option.withTextNameOther!== ''"
                class="d-inline-block ml-2"
                v-html="option.withTextNameOther"
              />
            </template>
          </div>
        </div>
      </template>
      <template v-else-if="field.fieldtype === 'hidden'">
        <input
          :id="`${field.fieldtype}_${field.fieldname}`"
          :type="field.fieldtype"
          :name="field.fieldname"
          :value="value"
        >
      </template>
      <template v-else>
        <input
          :id="`${field.fieldtype}_${field.fieldname}`"
          v-model.trim="value"
          :type="field.fieldtype"
          :placeholder="field.placeholder"
          :name="field.fieldname"
          @change="checkField"
        >
      </template>
      <div
        v-if="field.others && field.others !==''"
        class="other_text"
        v-html="field.others"
      />
    </div>
    <transition name="fade">
      <p
        v-if="error"
        class="text-danger"
        :style="(!field.fieldlabel && field.fieldtype === 'checkbox')?'margin-left:20px':''"
        v-html="getErrorMsg(error)"
      />
    </transition>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { en, zh } from "vuejs-datepicker/dist/locale";
import moment from "moment";

export default {
  name: "FormField",
  components: {
    Datepicker
  },
  props: ["field"],
  data() {
    let default_value = this.field.default_value;
    let additional = {};
    let other_option = null;
    switch (this.field.fieldtype) {
      case "dropdown":
        if (this.field.required && (!default_value || default_value == "")) {
          default_value = this.field.fieldoption[0].value;
        }
        break;
      case "checkbox":
        if (this.field.fieldoption.length > 0) {
          if (!default_value || default_value == "") {
            default_value = [];
          } else {
            try {
              var arr = JSON.parse(default_value);
              default_value = arr;
            } catch (e) {
              default_value = [default_value];
            }
          }
        }
        break;
      default:
        default_value = this.field.default_value;
        break;
    }
    if (this.field.fieldoption) {
      for (let i = 0; i < this.field.fieldoption.length; i++) {
        let option = this.field.fieldoption[i];
        if (option.type == "withText") {
          other_option = option;
          if (other_option.default_value) {
            additional[other_option.withTextName] = other_option.default_value;
          }
        }
      }
    }

    let data = {
      value: default_value,
      additional: additional,
      other_option: other_option,
      error: null,
      translation: {
        en: en,
        zh: zh
      }
    };
    if (this.field.fieldtype == "date") {
      data["disabledDates"] =
        this.field.format && this.field.min
          ? { to: moment(this.field.min, this.field.format).toDate() }
          : null;
      let format = this.field.format ? this.field.format : "YYYY-MM-DD";
      if (data.value) {
        data.value = moment(data.value, format).toDate();
      }
    }
    return data;
  },
  methods: {
    customFormatter(date) {
      let format = this.field.format ? this.field.format : "YYYY-MM-DD";
      return moment(date).format(format);
    },
    getErrorMsg(error_type) {
      if (!error_type || error_type == "") return "unknown_error";
      // let fieldtype = this.field.fieldtype;
      let params = {
        field: this.field.fieldlabel
      };

      let matches = error_type.match(/^([A-Z_]+)_([0-9]+)$/i);
      if (matches && matches.length > 0) {
        error_type = matches[1];
        params["number"] = matches[2];
      }
      // switch (this.field.fieldtype) {
      //   case "file":
      //     break;
      //   case "date":
      //     break;
      //   case "dropdown":
      //   case "checkbox":
      //   case "radio":
      //     if (error_type.startsWith("required")) error_type = "required_option";
      //     break;
      //   default:
      //     if (error_type.startsWith("required")) error_type = "required_field";
      //     break;
      // }

      return this.$t(`component.form.${error_type}`, params);
    },
    getFileName(path) {
      var parts = path.split("/");
      return parts.length > 0 ? parts[parts.length - 1] : path;
    },
    selectOption(option) {
      if (Array.isArray(this.value)) {
        if (!this.value.includes(option)) {
          this.value.push(option);
        }
      } else this.value = option;
    },
    checkFile(e) {
      // v-model value delay
      var item = this.field;
      let isValid = true;
      if (item.required) {
        var val = e.target.value;
        if (!val || val == "") {
          isValid = false;
        }
      }
      if (!isValid) {
        this.error = "required_file";
      } else {
        this.error = null;
      }
      return isValid;
    },
    checkField() {
      var item = this.field;
      let isValid = true;
      var val = this.value;

      if (
        item.required &&
        (!val || val == "" || (Array.isArray(val) && val.length == 0))
      ) {
        // this.error = `required_${item.fieldtype}`;
        switch (this.field.fieldtype) {
          case "dropdown":
          case "checkbox":
          case "radio":
            this.error = "required_option";
            break;
          default:
            this.error = "required_field";
            break;
        }

        isValid = false;
      }

      // if (val) {
      //   switch (item.fieldtype) {
      //     case "email":
      //       var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //       if (!re.test(val)) {
      //         this.error = "invalid_email";
      //         isValid = false;
      //       }
      //       break;
      //     case "number":
      //       // case "tel":
      //       var re = /^[0-9]+$/;
      //       if (!re.test(val)) {
      //         this.error = "invalid_number";
      //         isValid = false;
      //       }
      //       break;
      //   }
      // }
      if (isValid) {
        this.error = null;
      }
      return isValid;
    }
  }
};
</script>